import { FormattedMessage } from 'react-intl';
import './style.scss';

const SoldOut = () => (
  <div className="sold-out">
    <p className="sold-out__headline">
      <FormattedMessage id="basket.item.soldout.headline" />
    </p>
  </div>
);

export default SoldOut;
